import { IonCol, IonGrid, IonRow, IonImg } from '@ionic/react'
import { CounterInput } from 'components/counter-input'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IRoomSelectionBoxProps } from './room-selection-box-props.interface'
import './room-selection-box.scss'

const RoomSelectionBox: React.FC<IRoomSelectionBoxProps> = ({ room, numDays, dateFrom, dateTo, totalForRoom, onChangeRoomSelection }) => {
  const { t } = useTranslation()

  const [isSelected, setIsSelected] = useState(false)

  const onChangeRoomSelection_ = (value: number) => {
    setIsSelected(value > 0)
    onChangeRoomSelection(value)
  }

  return (
    <IonGrid className={'edisu-room-selection-box' + (isSelected ? ' room-selected' : '')}>
      <IonRow className="top-row">
        {room.immagine && (
          <IonCol size="12" sizeLg="4">
            <div className="thumb-container">
              <IonImg src={room.immagine} alt="" className="room-image" />
            </div>
          </IonCol>
        )}
        <IonCol size="12" sizeLg="6">
          <span className="edisu-text-small text-upper-bold">{room.descrizione}</span>

          {room.note && <p className="edisu-text-normal">{room.note}</p>}
          {/* {room.descrizioneTariffa && <p className="edisu-text-normal">{room.descrizioneTariffa}</p>} */}
        </IonCol>
      </IonRow>
      <IonRow className="bottom-row">
        <IonCol size="12" sizeLg="4" className="price-col">
          <span className="price-line">
            <span>{room.prezzo % numDays === 0 ? room.prezzo / numDays : (room.prezzo / numDays).toFixed(2).replace('.', ',')} €</span> /{' '}
            {t('per_night')}
          </span>
        </IonCol>
        <IonCol size="12" sizeLg="6" className="room-dates-col">
          <div className="room-dates">
            {numDays > 0 && <span className="edisu-text-small">{numDays + ' ' + (numDays === 1 ? t('night') : t('nights'))}</span>}
            {(dateFrom !== '' || dateTo !== '') && (
              <span className="edisu-text-normal room-dates-text">
                {dateFrom} / {dateTo}
              </span>
            )}
          </div>

          {dateFrom !== '' && dateTo !== '' && <span className="total-for-room">{totalForRoom} €</span>}
        </IonCol>

        <IonCol size="12" sizeLg="2" className="selection-col">
          <p className="edisu-text-small text-upper-bold">{t('select') + ` (MAX ${room.numeroDisponibilita})`}</p>

          <CounterInput initialValue={0} minValue={0} maxValue={room.numeroDisponibilita} onChangeValue={onChangeRoomSelection_} />
        </IonCol>
      </IonRow>
    </IonGrid>
  )
}

export default RoomSelectionBox
